import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import { TableColumn } from 'react-data-table-component';
import DataGrid from '../../Component/DataGrid/DataGrid';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import { IReferral, RefereesProps, RefereeState, RefereeDetails } from './Interface';
import moment from 'moment';
import { SlideUpTransition } from '../../Component/Reusables/Transitions';
import ReferralService from '../../Services/ReferralService';

// Main class component for RefereesDialog
class RefereesDialog extends React.Component<RefereesProps, RefereeState> {
    static contextType = SyncContext;
    context!: SyncContextType;

    private tableColumns: TableColumn<RefereeDetails>[] = [
        {
            name: 'Referee Name',
            selector: row => row.refereeName || 'N/A',
            sortable: true,
            minWidth: '150px',
            wrap: true,
            id: 'refereeName'
        },
        {
            name: 'Email',
            selector: row => row.email || 'N/A',
            sortable: true,
            minWidth: '200px',
            wrap: true,
            id: 'email'
        },
        {
            name: 'Country',
            selector: row => row.country || 'N/A',
            sortable: true,
            id: 'country'

        },
        {
            name: 'Referee Code',
            selector: row => `${row.refereeCode ?? 0}`,
            sortable: true,
            right: true,
            minWidth: "100px",
            id: 'refereeCode'
        },
        {
            name: 'Referee Bonus',
            selector: row => `${row.currencySymbol}${row.refereeBonus ?? 0}`,
            sortable: true,
            right: true,
            minWidth: "100px",
            id: 'refereeBonus'
        },
        {
            name: 'Referrer Bonus',
            selector: row => `${row.currencySymbol}${row.referrerBonus ?? 0}`,
            sortable: true,
            right: true,
            minWidth: "100px",
            id: 'referrerBonus'
        },
        {
            name: 'Min Transaction Amount',
            selector: row => `${row.currencySymbol}${row.minTransactionAmount ?? 0}`,
            sortable: true,
            right: true,
            id: 'minTransactionAmount'
        },
        {
            name: 'First Transaction Amount',
            selector: row => `${row.currencySymbol}${row.firstTransactionAmount ?? 0}`,
            sortable: true,
            right: true,
            id: 'firstTransactionAmount'
        },
    ];


    constructor(props_: RefereesProps) {
        super(props_);
        this.state = {
            accessToken: '',
            referralData: [],
            currentPage: 1,
            currentRowsPerPage: 10,
            totalRows: 0,
            searchText: '',
            selectedFilter: '',
            filterValue: '',
            isOpenReferralSettings: false,
            isOpenRefreesDialog: true,
        };
    }

    async componentDidMount() {
        try {
            const accessToken_ = await loadFromLocalStorage('accessToken');
            if (!accessToken_) {
                localStorage.clear();
                window.location.href = '/';
                return;
            }

            this.setState({ accessToken: accessToken_.toString() }, () => {
                this.getReferralData();
            });
        } catch (error) {
            console.error('Error loading referral data:', error);
        }
    }

    private getReferralData = async () => {
        const { accessToken, currentPage, currentRowsPerPage, searchText, selectedFilter, filterValue } = this.state;

        const pageIndex = currentPage - 1;

        let pagination: any = {
            pageNumber: pageIndex,
            recordPerPage: currentRowsPerPage
        };

        if (searchText) {
            pagination["searchText"] = searchText;
        }

        if (selectedFilter) {
            pagination[selectedFilter] = filterValue;
        }

        try {
            const response = await ReferralService.getRefereeList(accessToken, pagination, this.props.selectedReferrerId);
            if (response?.ok) {
                const result = await response.json();

                this.setState({
                    referralData: result.refereeList || [],
                    totalRows: result.totalPages || 0
                });
            }
        } catch (error) {
            console.error("Error fetching referral list:", error);
        }
    };

    render() {
        const { open, onClose } = this.props;
        const { accessToken, isOpenReferralSettings, isOpenRefreesDialog, referralData } = this.state;
        return (
            <Dialog open={open} onClose={() => onClose?.(false, "cancel")} fullWidth keepMounted maxWidth="lg" TransitionComponent={SlideUpTransition}>
                {/* <DialogTitle>Referees</DialogTitle> */}
                <DialogContent className="subMenuModal" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                    <DataGrid
                        title="Referees"
                        search="Referees"
                        defaultSearch={this.state.searchText}
                        onSearch={(text) => this.setState({ searchText: text, currentPage: 1 }, this.getReferralData)}
                        onFilterChange={(selectedFilter, filterValue) =>
                            this.setState({ selectedFilter, filterValue, currentPage: 1 }, this.getReferralData)
                        }
                        columns={this.tableColumns}
                        data={referralData}
                        onChangePage={(page) => this.setState({ currentPage: page }, this.getReferralData)}
                        onChangeRowsPerPage={(rows, page) => this.setState({ currentRowsPerPage: rows, currentPage: page }, this.getReferralData)}
                        pagination
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClose?.(false, "cancel")}>Cancel</Button>
                    <Button color="secondary" variant="contained">Save</Button>
                </DialogActions>
            </Dialog >
        );
    }
}

export default RefereesDialog;
